import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-add-ticket',
  templateUrl: './add-ticket.component.html',
  styleUrls: ['./add-ticket.component.css']
})
export class AddTicketComponent implements OnInit {

  i: any;
  deleteId: any;
  ticketcontroller:any = [];
  TicketTask: any = [];
  users: any = [];
  TicketTaskdata: any = [];
  tagUsersdropdownList  = [];
  tagUsersselectedItems:any = [];
  tagUsersdropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'userId',
    textField: 'userName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  usersList : any = [];
  formSubmit = false;
  addClassType = ""
  assignInput = ""
  ticketId = ''


   serviceData:any = []

   ProductParams:any = []
   keyValueList:any = []

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  form: any | FormGroup
  Taskform:any | FormGroup
  modelSubtitle = false
  IDs:any = []
  data:any = []
  fileType:any;
  file = '';
  imgView: any = ""
  images:any= [];
  videos:any= [];
  audios:any= [];
  description = "";
  typeId = "";
  heading = "";
  details = "";
  source = "";
  customerID = "";
  customerType = ""
  searchFilter = ''
  newTicketCount= 0
  // ticketId = 0
  cid:any;
  buttonDisable = false;
  usersWithoutCustomers:any = [];
  userCred: any
  
  ngOnInit(): void {
    this.cid  = sessionStorage.getItem('cid')
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);

    // this.getUsers();
    // this.getUsersWithoutCustomers()
    this.generic_service.gettypeids().subscribe((res: any) => {
      console.log(res)
      this.IDs = res.response
    })
    
    this.form = this.fb.group({
      description: [''],
      typeId: ['',[Validators.required]],
      heading:['',[Validators.required]],
      details:['',[Validators.required]],
      source:[''],
      customerID:[''],
      customerType:[''],
      customerName:[''],
      customerPhNo:[''],
      assignedToUserName:['']
    });

    this.getAllServices()
    // this.getParamByType()




  }

  onItemSelect(item: any) {
    console.log(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  getUsersWithoutCustomers(){
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res:any)=>{
        this.usersWithoutCustomers = res.response;
      }
    )
  }


  getParamByType(){
    this.generic_service.getParamByType('TICKETPARAM').subscribe(
      (response:any)=>{
        console.log(response);
        this.ProductParams = response.response;
        console.log(this.ProductParams);

        for(let i=0; i<this.ProductParams.length;i++){
          this.keyValueList.push(
            {
              "key": this.ProductParams[i].name,
              "value": "",
              "possibleValue": this.ProductParams[i].possibleValue
            }
          )
        }
        console.log(this.keyValueList);

      }
    )
  }

  addcontroller(){

    this.form.patchValue({
        customerID: this.userCred.userId,
        customerName: this.userCred.userName,
        customerPhNo: this.userCred.userMobileNo,
      }
    )

    if(this.userCred.userType == "Client"){
      this.form.patchValue(
        {
          customerType: this.userCred.userId,
        }
      )
    }


    this.formSubmit = true;
    if(!this.form.valid){
      console.log(this.form.value)
      return
    }
    this.buttonDisable = true;
    let tagUserIds = [];
    for(let i = 0; i < this.tagUsersselectedItems.length; i++) {
      tagUserIds.push(Number(this.tagUsersselectedItems[i].userId))
    }

    
    let keyValueList:any = []

    for(let i = 0; i < this.keyValueList.length; i++){
      keyValueList.push(
        {
          "key": this.keyValueList[i].key,
          "value": this.keyValueList[i].value
        }
      )
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "typeId": Number(this.form.get('typeId').value),
      "ticketSubTypeId": 0,
      "parentTicketId": 0,
      "priorityId": 0,
      "ticketStatus": [
        {
          "note": "Ticket Created by"+ " " + sessionStorage.getItem('userName'),
          "ticketStatus": "OPEN"
        }
      ],
      "heading": String(this.form.get('heading').value),
      "details":  String(this.form.get('details').value),
      "resolution": "",
      "source":  "Admin",
      "raisedBy": "",
      "remarks": "",
      "assignedTo": "",
      "assignedToUserName": String(this.form.get('assignedToUserName').value),
      "startTime": 0,
      "endTime": 0,
      "customerID": String(this.form.get('customerID').value),
      "customerName": String(this.form.get('customerName').value),
      "customerNotes": "",
      "technicianNotes": "",
      "customerPhNo": String(this.form.get('customerPhNo').value),
      "customerAddress": "",
      "startNotes": "",
      "endNotes": "",
      "pendingNotes": "",
      "customerType": String(this.form.get('customerType').value),
      "latestTicketStatus": "OPEN",
      "assignedBy": "",
      "latitude": "",
      "startLatitude": "",
      "startLongitude": "",
      "endLatitude": "",
      "endLongitude": "",
      "agentId": 0,
      "audio": [],
      "video": [],
      "image": this.images,
      "tagUserIds": tagUserIds,
      "assignedOn": 0,
      "serviceQuality": 0,
      "keyValueList": keyValueList,
      "longitude": "",
      "ticketNo": 0,
      "cid": this.cid
    }

 
    console.log(body)
    this.generic_service.addcontroller(body).subscribe(
      (response:any)=>{
        console.log(response)
        let taskId = response.response.id+'_1'
        this.toastr.success(response.message);
        this.tagUsersselectedItems = []
        this.formSubmit = false;
        this.buttonDisable = false;
        this.images = []

        this.form.reset()
      },(err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);

      }
    )
  }
  
  getUsers(){
    this.generic_service.getUsers().subscribe(
      (res:any)=>{
        this.users = res.response;
        this.usersList = res.response;
        this.tagUsersdropdownList = res.response
        console.log(res);
      }
    )
  }

  onChange(event: any) {
    this.file = event.target.files[0];
    this.onUpload()
  }

  onUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.images.push(event.response)
    });
  }

  viewImg(image: any){
    this.imgView = image
    document.getElementById("viewImgModel")?.click()

  }

  removeImg(index: any){
    this.images.splice(index,1)
  }
  
  addImageBtn(){
    document.getElementById("add-image-btn")?.click()
  }

  addClass(value:any){
    console.log(value)
    if(this.addClassType == ''){
      let list = document.getElementById('assign-and-tag-data')
      if(list?.classList.contains('assign-show')){
        list.classList.remove('assign-show')
        this.addClassType = ''
      }else{
        list?.classList.add('assign-show')
        this.addClassType = value
      }
    }else{
      if(this.addClassType == value){
        let list = document.getElementById('assign-and-tag-data')
        if(list?.classList.contains('assign-show')){
          list.classList.remove('assign-show')
          this.addClassType = ''
        }else{
          list?.classList.add('assign-show')
          this.addClassType = value
        }
      }else{
        this.addClassType = value
      }
    }
  }

  taskAssignToUser(taskId:any, userId: any,taskStatus:any,name:string){
    let note = "";
    // if(taskStatus == "REASSIGNED"){
    //   note = "Task ASSIGNED to " + name;
    // }
    note = "Task ASSIGNED to " + name;
    let body = {
      "taskId": Number(taskId),
      "userId": Number(userId),
      "taskStatusDTO": {
        "note": String(note),
        "taskStatus": String(taskStatus),
        "updatedDate": 0
      }
    }
    console.log(body)
    this.generic_service.taskAssignToUser(body).subscribe(
      (response:any)=>{
        console.log(response);
        this.addClass('assignedTo')
        // this.getSingleTask(taskId);
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }


  getSingleTask(id:any){
    console.log(id)
    this.generic_service.getSingleTask(id).subscribe(
      (res:any)=>{
        console.log(res);
      }
    )
  }

  getAllServices(){
    this.generic_service.getAllServices().subscribe(
      (response:any)=>{
        this.serviceData = response.response;
        console.log(response)
      }
    )
  }
}